import axios from 'axios'

// config
import baseUrl from '../config'

const shiftLogsPath = '/sef/shift-logs'

const axiosInstance = axios.create({
  baseURL: baseUrl,
  withCredentials: true
})

export const fetchSignedParticipants = async params => {
  const response = await axiosInstance.get('/sef/shift-log-signed-participants', {
    params
  })

  return response.data
}

export const fetchShiftLogEntries = async params => {
  const response = await axiosInstance.get(shiftLogsPath, {
    params
  })

  return response.data
}

export const fetchShiftLogEntry = async entryId => {
  const response = await axiosInstance.get(`${shiftLogsPath}/${entryId}`)

  return response.data
}

export const createShiftLogEntry = async data => {
  return await axiosInstance({
    method: 'POST',
    url: shiftLogsPath,
    data
  })
}

export const updateShiftLogEntry = async ({ entryId, ...data }) => {
  return await axiosInstance({
    method: 'POST',
    url: `${shiftLogsPath}/${entryId}`,
    data
  })
}
